<template>
  <d-row>
    <d-col lg="8" xl="9">
      <d-card class="card-small mb-4">
        <d-card-header
          class="border-bottom d-flex justify-content-between align-items-center"
        >
          <h6 class="m-0">Template do Jogo</h6>
        </d-card-header>

        <d-card-body class="p-3">
          <puzzle-form ref="leadForm" :template-mode="true" />
        </d-card-body>
      </d-card>
    </d-col>
    <!-- Sidebar Widgets -->
    <d-col lg="4" xl="3" sm="12">
      <d-card class="card-small mb-3">
        <d-card-header class="border-bottom">
          <h6 class="m-0">Ações</h6>
        </d-card-header>

        <d-card-body class="px-0">
          <d-list-group flush>
            <d-list-group-item class="p-3">
              <d-button
                @click.prevent="resetTemplateQuestions()"
                class="btn-danger btn-block mt-2"
              >
                Limpar Template
              </d-button>
            </d-list-group-item>
          </d-list-group>
        </d-card-body>
        <d-card-footer
          class="border-top d-flex flex-column flex-xl-row justify-content-around"
        >
          <d-button
            @click="save"
            type="button"
            class="btn-primary mb-3 mb-xl-0 col-xl-5"
          >
            Salvar
          </d-button>
          <router-link
            class="btn-secondary btn text-white col-xl-5"
            :to="{ name: 'admin-crossword-template-list', params: { page: 1 } }"
          >
            Cancelar
          </router-link>
        </d-card-footer>
      </d-card>
    </d-col>
  </d-row>
</template>

<script>
import Events from '_utils/events';
import { cloneDeep } from '_utils';
import PuzzleForm from './PuzzleForm.vue';
import { _LOAD_MODEL_, MODEL } from './PuzzleModel';

export default {
  name: 'PuzzleTemplatePage',
  components: { PuzzleForm },
  computed: {
    puzzle() {
      const { puzzle } = this.$store.state.puzzle;
      if (puzzle) {
        Events.$emit(_LOAD_MODEL_, puzzle);
        return puzzle;
      }
      return cloneDeep(MODEL);
    },
  },
  methods: {
    save() {
      this.$refs.leadForm.save();
    },
    resetTemplateQuestions() {
      this.$refs.leadForm.resetTemplateQuestions();
    },
  },
};
</script>
